import * as React from 'react';
import { useSelector } from 'react-redux';

import { Card } from '../Card';
import { Preloader } from '../Preloader';
import { WrapContainer } from '../WrapContainer';
import { ResultsEmptyForAuthorizationContainer } from '../../containers/ResultsEmptyForAuthorizationContainer';
import { ResultsEmptyContainer } from '../../containers/ResultsEmpty';
import { selectResults } from '../../selectors';
import { IPageState } from '../../types/page';
import { EGetFavoriteEntitiesStatus, IResultsState } from '../../types/results';

import * as styles from './styles.css';

interface IResultsMobile {
  results: IResultsState;
  page: IPageState;
  isFavoritesForAuthorizationEnabled: boolean;
  isExperimentEnabled?: boolean;
  removeFavorite(entityId: number): void;
}

export const ResultsMobile: React.FC<IResultsMobile> = ({
  results,
  page,
  isFavoritesForAuthorizationEnabled,
  isExperimentEnabled,
  removeFavorite,
}) => {
  const { status, favoriteEntities, total } = results;

  const { hasMore } = useSelector(selectResults);

  if (favoriteEntities.length === 0) {
    return <ResultsEmptyContainer isExperimentEnabled={isExperimentEnabled} />;
  }

  if (isFavoritesForAuthorizationEnabled) {
    return <ResultsEmptyForAuthorizationContainer />;
  }

  if (isExperimentEnabled && !hasMore) {
    return (
      <WrapContainer>
        <div className={styles['container']}>
          {favoriteEntities.map((favoriteEntity, index) => (
            <Card
              key={'item-' + favoriteEntity.entityId}
              total={total}
              favoriteEntity={favoriteEntity}
              page={page}
              position={index + 1}
              removeFavorite={removeFavorite}
            />
          ))}
          {[EGetFavoriteEntitiesStatus.Loading, EGetFavoriteEntitiesStatus.NextPageLoading].includes(status) && (
            <div key="preloader" className={styles['preloader']}>
              <Preloader size={64} />
            </div>
          )}
        </div>
      </WrapContainer>
    );
  }

  return (
    <div className={styles['container']}>
      {favoriteEntities.map((favoriteEntity, index) => (
        <Card
          key={'item-' + favoriteEntity.entityId}
          total={total}
          favoriteEntity={favoriteEntity}
          page={page}
          position={index + 1}
          removeFavorite={removeFavorite}
        />
      ))}
      {[EGetFavoriteEntitiesStatus.Loading, EGetFavoriteEntitiesStatus.NextPageLoading].includes(status) && (
        <div key="preloader" className={styles['preloader']}>
          <Preloader size={64} />
        </div>
      )}
    </div>
  );
};
